import {RolesEnum} from "../enums/RolesEnum";

export const EnrolledRoutes = {
    home: [],
    customers: [],
    users: [
        RolesEnum.Admin,
    ],
}